import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo } from 'react';
import { SET_SUBMITTED_ANSWERED_PATIENT_CPP, SET_RESOLVED_ANSWERED_PATIENT_CPP, SET_ALL_CPP, SET_CPP_NOTES } from './constants';
/**
 * the reason we set those plans to null is because it is easier
 * to handle the payload logic in component based on action and not on types
 */

const initialState = {
  answeredSubmittedCPPGlobal: null,
  answeredResolvedCPPGlobal: null,
  allCPPGlobal: null,
  cppNotesGlobal: {},
  dispatchCPP: null
};
const initCPPGlobalContext = {
  answeredSubmittedCPPGlobal: null,
  answeredResolvedCPPGlobal: null,
  allCPPGlobal: null,
  cppNotesGlobal: {},
  dispatchCPP: null
};
export const CPPGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    // heavy API call to get answered data
    // list of answered patient CPP that have been submitted - excludes WIP and resolved
    case SET_SUBMITTED_ANSWERED_PATIENT_CPP:
      newState.answeredSubmittedCPPGlobal = action.payload;
      break;
    // heavy API call to get answered data
    // list of answered patient CPP that have been resolved - excludes Submitted and resolved

    case SET_RESOLVED_ANSWERED_PATIENT_CPP:
      newState.answeredResolvedCPPGlobal = action.payload;
      break;
    // list of all CPP available for the patient

    case SET_ALL_CPP:
      newState.allCPPGlobal = action.payload;
      break;

    case SET_CPP_NOTES:
      newState.cppNotesGlobal = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const CPPGlobalContext = /*#__PURE__*/createContext(initCPPGlobalContext);
export const CPPGlobalDispatchContext = /*#__PURE__*/createContext({});
export const CPPGlobalContextConsumer = CPPGlobalContext.Consumer;
export const CPPGlobalDispatchContextConsumer = CPPGlobalDispatchContext.Consumer;
export const CPPGlobalContextProvider = ({
  children
}) => {
  const [{
    answeredSubmittedCPPGlobal,
    answeredResolvedCPPGlobal,
    allCPPGlobal,
    cppNotesGlobal
  }, dispatch] = useReducer(CPPGlobalContextReducer, initialState);
  const context = useMemo(() => ({
    answeredSubmittedCPPGlobal,
    answeredResolvedCPPGlobal,
    allCPPGlobal,
    cppNotesGlobal,
    dispatchCPP: dispatch
  }), [answeredSubmittedCPPGlobal, answeredResolvedCPPGlobal, allCPPGlobal, cppNotesGlobal, dispatch]);
  return /*#__PURE__*/React.createElement(CPPGlobalContext.Provider, {
    value: context
  }, children);
};
export function withCPPGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(CPPGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(CPPGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default CPPGlobalContext;